const SkeletonCard = () => (
  <div className="relative w-full min-w-sm overflow-hidden bg-lightBackground rounded-3xl bg-bgCard animate-pulse">
    <div className="relative h-[180px] w-full bg-gray-300"></div>
    <div className="p-4">
      <div className="h-4 bg-gray-300 rounded mb-2"></div>
      <div className="h-4 bg-gray-300 rounded w-3/4 mb-4"></div>
      <div className="flex items-center gap-2">
        <div className="h-4 w-4 bg-gray-300 rounded-full"></div>
        <div className="h-4 bg-gray-300 rounded w-1/2"></div>
      </div>
    </div>
  </div>
);
export default SkeletonCard;
